export enum PalettePresetEnum {
  neutral = "neutral",
  error = "error",
  warning = "warning",
  success = "success",
  info = "info",
  orange = "orange",
  emerald = "emerald",
  cyan = "cyan",
  fuchsia = "fuchsia",
  pink = "pink",
  lime = "lime",
  outlined = "outlined",
  white = "white",
}
export enum AnimationFileNameEnum {
  failed = "failed",
  empty = "empty",
  expirenza = "expirenza",
}
